// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"17e863a7","644":"9b7f0158","732":"82d7e5b7"}[chunkId] + ".chunk.js";
};